import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetOAuthCredentialAssociatedWithResourceParams {
  resourceId: string;
  resourceType: string;
}

export interface IGetOAuthCredentialAssociatedWithResourceResult extends IResult {
  id: string;
  type: string;
  username: string;
}

export class GetOAuthCredentialAssociatedWithResourceRequest extends Request<IGetOAuthCredentialAssociatedWithResourceParams, IGetOAuthCredentialAssociatedWithResourceResult> {
  constructor(params: IGetOAuthCredentialAssociatedWithResourceParams) {
    super('getOAuthCredentialAssociatedWithResource', params);
  }
}
